@let isCellView = isCellView$ | async;
@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let hasAbsenceUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Absence);

@if (
  {
    actionBarVisible:
      'portal-shift-timeline-drag-and-drop-mode-action-bar'
      | featureFlagPure
      | async,
    emptyShiftVisible:
      'portal-shift-timeline-quick-shift-creation' | featureFlagPure | async,
    newAbsenceVisible:
      'Shift-timeline-page-create-new-absence' | featureFlagPure | async,
    isAssignmentMode: dragAndDropModeService.isAssignmentMode$ | async,
    zoomLevel: zoomLevel$ | async,
  };
  as data
) {
  <div class="d-flex action-bar ps-3" [class.pe-3]="isActionCardOpen">
    @if (data.actionBarVisible) {
      <div class="d-flex">
        <div
          class="icon me-3 m-auto"
          (click)="dragAndDropModeService.toggleAssignmentMode()"
        >
          <div
            class="action-icon m-auto"
            [class.selected]="data.isAssignmentMode"
          >
            <fa-icon [icon]="faAssign"></fa-icon>
          </div>
          <span class="action-text mt-1">
            <span>{{
              'page.shift_timeline.action_bar.assignment' | translate
            }}</span>
            <span class="d-block shortcut">A</span>
          </span>
        </div>
        <div
          class="icon m-auto"
          [class.me-3]="isActionCardOpen"
          [class.icon-disabled]="
            !hasShiftUpdatePermission || !hasAbsenceUpdatePermission
          "
          nz-tooltip
          [nzTooltipTitle]="
            !hasShiftUpdatePermission || !hasAbsenceUpdatePermission
              ? ('general.forbidden_action' | translate)
              : ''
          "
          (click)="
            hasShiftUpdatePermission &&
              hasAbsenceUpdatePermission &&
              dragAndDropModeService.toggleMoveMode()
          "
          data-test-id="wilson-drag-drop-mode-action-bar:move-mode"
        >
          <div
            class="action-icon m-auto"
            [ngClass]="isActionCardOpen ? 'card-open' : 'card-close'"
            [class.selected]="dragAndDropModeService.isMoveMode$ | async"
          >
            <fa-icon [icon]="faArrowsLeftRight"></fa-icon>
          </div>
          <span
            class="action-text mt-1"
            [ngClass]="isActionCardOpen ? 'card-open' : 'card-close'"
          >
            <span>{{ 'page.shift_timeline.action_bar.move' | translate }}</span>
            <span class="d-block shortcut">V</span>
          </span>
        </div>
        <div
          class="icon m-auto"
          [class.icon-disabled]="isCellView || data.isAssignmentMode"
          (click)="
            !isCellView &&
              !data.isAssignmentMode &&
              dragAndDropModeService.toggleSnapping(
                data.zoomLevel ?? ZOOM_LEVEL.DEFAULT
              )
          "
        >
          <div
            class="action-icon m-auto"
            [ngClass]="isActionCardOpen ? 'card-open' : 'card-close'"
            [class.selected]="dragAndDropModeService.isSnapping$ | async"
          >
            <fa-icon [icon]="faSnappingIcon"></fa-icon>
          </div>
          <span
            class="action-text mt-1"
            [ngClass]="isActionCardOpen ? 'card-open' : 'card-close'"
          >
            <span>{{
              'page.shift_timeline.action_bar.snapping' | translate
            }}</span>
            <span class="d-block shortcut">CTRL + M</span>
          </span>
        </div>
      </div>
    }
  </div>
}
